import React from 'react'

const UpcommingMeetingCard = ({ meeting }) => {
    

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    return (
        <div className="upcommming-meeting-card">
            <div
                id={
                    meeting?.deptartmentTagMaster?.deptTag=== "Facility" ?
                        "facillity" :
                        meeting?.deptartmentTagMaster?.deptTag=== "IT" ?
                            "it" :
                            meeting?.deptartmentTagMaster?.deptTag=== "HR" ?
                                "hr" :
                                "governance"
                }
                className="meeting-date-icon"
            >
                <span>
                    {new Date(meeting?.parseStartDate).getDate()}
                </span>
                <span>
                    {monthNames[new Date(meeting?.parseStartDate).getMonth()]}
                </span>
            </div>
            <div className="upcomming-meeting-info" style={{ textOverflow: 'ellipsis' }}>
                <span style={{ color: "#101010", height: '20px', textOverflow: 'ellipsis', width: '250px', overflow: 'hidden', textWrap: 'nowrap', fontSize: "13px", fontWeight: "600", paddingRight: '7px' }}>{meeting?.meetingSubject}</span>
                <span style={{ color: "#101010", fontSize: "11px" }}>{meeting?.startTime} - {meeting?.endTime === "11:59 PM" ? "12:00 AM" : meeting?.endTime}</span>
            </div>
            <div className="upcoming-meeting-tag" style={{ paddingRight: 5 }}>
                <span
                    // id={
                    //     meeting.departmentTagMaster?.deptTag === "Facility"
                    //         ? "facilityColor"
                    //         : meeting.departmentTagMaster?.deptTag === "IT"
                    //             ? "itColor"
                    //             : meeting.departmentTagMaster?.deptTag === "HR"
                    //                 ? "hrColor"
                    //                 : "governanceColor"
                    // }

                    id={
                        meeting?.deptartmentTagMaster?.deptTag=== "Facility" ?
                            "facillity" :
                            meeting?.deptartmentTagMaster?.deptTag=== "IT" ?
                                "it" :
                                meeting?.deptartmentTagMaster?.deptTag=== "HR" ?
                                    "hr" :
                                    "governance"
                    }
                    
                    className="circleSpan"
                ></span>
            </div>

        </div>
    )
}

export default UpcommingMeetingCard